<template>
    <div class="modal fade" id="viewPrintNoc">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printNoc()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printNoc">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td class="text-right"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br></h4>
                         </td>
                        </thead>
                      </table>
                      <hr style="border: 4px solid gray;">
                      <p class="text-center"><strong>(Incorporated under the Companies Act, 2013) Registered by Ministry of Corporate Affairs, Govt. of India</strong></p>
                      <!-- <h3 class="text-center"><strong>No Objection Certificate</strong></h3> -->
                      <div>
                        <p class="text-right">Date: {{curDate | myDate}}</p>
                        <p><strong>Loan Application No :</strong> {{seeRecord.applicationNo}}</p>
                        <p v-if="seeRecord.disbursement"><strong>Loan Amount :</strong> {{ planAmt(seeRecord.disbursement) }}</p>
                        <p><strong>Customer Name : </strong><strong v-if="seeRecord.member">{{seeRecord.member.name}} ({{seeRecord.member.code}})</strong></p>
                        <p><strong>Mobile : </strong> <strong v-if="seeRecord.member">{{seeRecord.member.mobile}}</strong></p>
                        <p v-if="seeRecord.disbursement"><strong>Loan Disbursement Date :</strong> {{seeRecord.disbursement.disbursementDate}}</p>
                        <br>
                        <h3 class="text-center">Subject - Non Objection Certificate (NOC)</h3>
                        <strong>Dear Customer</strong>
                        <p>With reference to above mentioned Subject we hereby issue the “LOAN CLOSURE LETTER” of Your Loan Account No <strong>{{seeRecord.applicationNo}}</strong> With The Name <strong v-if="seeRecord.member">{{seeRecord.member.name}}</strong> has fulfilled your entire obligation and paid all the outstanding dues under the said Loan Agreement.</p>
                        <br><br>
                        <p>This is for your information and needful.
                            <br>Your faithfully
                        </p><br>
                        <p>Chief Operating Manager</p><br>
                        <strong>Disclaimer:</strong>
                        <p>The NOC letter Will not be applicable in case this loan gets closed due to technical error or if the same is unpaid</p>
                        <br><br>
                        <p class="text-center">This is system generated letter and does not require any signature.</p>
                      </div><br>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  data () {
    return {
      curDate: new Date().toISOString().slice(0, 10)
    }
  },
  methods: {
    planAmt (disbursement) {
      var pln = JSON.parse(disbursement.plan)
      if (disbursement.loanAmount) {
        this.seeRecord.loanAmount = disbursement.loanAmount
        this.seeRecord.fileCharge = disbursement.fileCharge
        this.seeRecord.processingFee = disbursement.processingFee
      }
      if (pln.planType === 'normalReduced' || pln.planType === 'special') {
        return this.showPlanAmtReduced(pln)
      } else {
        return this.showPlanAmtNormal(pln)
      }
    },
    showPlanAmtNormal (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.amount * pl.processingFee) / 100
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount
      } else {
        return pl.amount
      }
    },
    showPlanAmtReduced (pl) {
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount + this.seeRecord.fileCharge + this.seeRecord.processingFee
      } else {
        if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'false') {
          return parseInt(pl.amount)
        } else if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'true') {
          return parseInt(pl.amount) + parseInt(pl.processingFee)
        } else if (pl.fileChargeIncludeAmt === 'true' && pl.processingFeeIncludeAmt === 'false') {
          return parseInt(pl.amount) + parseInt(pl.fileCharge)
        } else {
          return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
        }
        // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      }
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
    },
    printNoc () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printNoc').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    memberDetail: {},
    mem: {},
    pl: {},
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// Noc.vue?4c145ce8